import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import {
  provideClientHydration,
  withEventReplay,
} from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
  HttpClient,
  provideHttpClient,
  withFetch,
} from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TablerIconsModule } from "angular-tabler-icons";
import { firstValueFrom } from "rxjs";

import { routes } from "./app.routes";
import { LandingSeoService } from "./core/landing-seo.service";
import { LandingSettingsService } from "./core/landing-settings.service";
import { landingTablerIcons } from "./landing-icons";

export function landingTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

function initLandingApp(
  settings: LandingSettingsService,
  translate: TranslateService,
  seo: LandingSeoService,
): () => Promise<unknown> {
  return () => {
    settings.applyThemeToDocument();
    const lang = settings.getLanguage();
    translate.setDefaultLang(lang);
    return firstValueFrom(translate.use(lang)).then(() => {
      seo.apply();
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: initLandingApp,
      deps: [LandingSettingsService, TranslateService, LandingSeoService],
      multi: true,
    },
    importProvidersFrom(
      TablerIconsModule.pick(landingTablerIcons),
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: landingTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
